import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './providers/AuthProvider';
import { ThemeProvider } from './providers/ThemeProvider';
import { Layout } from './components/Layout';
import { HomePage } from './pages/HomePage';
import { DashboardPage } from './pages/DashboardPage';
import { CalculatorPage } from './pages/CalculatorPage';
import { RecipeListPage } from './pages/RecipeListPage';
import { RecipeDetailPage } from './pages/RecipeDetailPage';
import { RecipeBuilderPage } from './pages/RecipeBuilderPage';
import { JournalListPage } from './pages/JournalListPage';
import { JournalEntryFormPage } from './pages/JournalEntryFormPage';
import { JournalDetailPage } from './pages/JournalDetailPage';
import { IngredientsListPage } from './pages/IngredientsListPage';
import { IngredientFormPage } from './pages/IngredientFormPage';
import { IngredientDetailPage } from './pages/IngredientDetailPage';
import { ImportPage } from './pages/ImportPage';
import { LoginPage } from './pages/LoginPage';
import { SignUpPage } from './pages/SignUpPage';
import { UserProfilePage } from './pages/UserProfilePage';
import { ChatPage } from './pages/ChatPage';
import { ProtectedRoute } from './components/ProtectedRoute';

export function App() {
  return (
    <ThemeProvider>
    <AuthProvider>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignUpPage />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/calculator" element={<CalculatorPage />} />
            <Route path="/recipes" element={<RecipeListPage />} />
            <Route path="/recipes/new" element={<RecipeBuilderPage />} />
            <Route path="/recipes/:recipeId" element={<RecipeDetailPage />} />
            <Route path="/recipes/:recipeId/edit" element={<RecipeBuilderPage />} />
            <Route path="/ingredients" element={<IngredientsListPage />} />
            <Route path="/ingredients/new" element={<IngredientFormPage />} />
            <Route path="/ingredients/import" element={<ImportPage />} />
            <Route path="/ingredients/:ingredientId" element={<IngredientDetailPage />} />
            <Route path="/ingredients/:ingredientId/edit" element={<IngredientFormPage />} />
            <Route path="/journal" element={<JournalListPage />} />
            <Route path="/journal/new" element={<JournalEntryFormPage />} />
            <Route path="/journal/:entryId" element={<JournalDetailPage />} />
            <Route path="/profile" element={<UserProfilePage />} />
            <Route path="/chat" element={<ChatPage />} />
          </Route>
        </Route>
      </Routes>
    </AuthProvider>
    </ThemeProvider>
  );
}
